module.exports = __webpack_public_path__ + "img/img16.0694e682.svg";